import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from 'services/api/api';

import { mapErrorToToastProps } from '../../../../../../utils/forms/mapErrorToToastProps';
import { familyMessages } from '../variables/familyMessages';
export const createProductModel = async body => {
	const response = await api.post('/model-product', body);
	return response.data;
};

export const useCreateProductModel = (
	inputName?: string,
	formProps?,
	setAutocompleteData?
) => {
	const queryClient = useQueryClient();

	const toast = useToast();

	return useMutation(createProductModel, {
		onSuccess: success => {
			queryClient.invalidateQueries(['model-product-list']);
			queryClient.invalidateQueries(['model-product']);

			queryClient.refetchQueries(['model-product-list']);
			queryClient.refetchQueries(['model-product']);

			toast({
				title: familyMessages.MSG_MODEL_CREATED_SUCCESS,
				description: familyMessages.MSG_MODEL_CREATED_SUCCESS,
				position: 'bottom-left',
				status: 'success',
				duration: 8000,
				isClosable: true,
			});

			if (inputName && formProps) {
				const { setValue } = formProps;

				setValue(inputName, String(success.id));

				if (setAutocompleteData)
					setAutocompleteData(prev => ({
						...prev,
						product_model: success,
					}));
			}
		},
		onError: (error: any, variables, context) => {
			const toastErrors: Array<any> = mapErrorToToastProps(
				error,
				familyMessages.MSG_MODEL_CREATE_ERROR
			);
			toastErrors?.forEach(element => toast(element));
		},
	});
};
